module.exports = __webpack_public_path__ + "3dd3976eca43d0b4a61fe4d9e27d0b03.pdf";